

module.exports = __webpack_require__.stylable.create(
    "dropdownoption141330405",
    {"classes":{"root":"dropdownoption141330405__root","highlight":"dropdownoption141330405__highlight","nonHighlight":"dropdownoption141330405__nonHighlight"},"vars":{},"stVars":{"hoverBackgroundColor":"lightgrey","selectedBackgroundColor":"grey","selectedHoverBackgroundColor":"dimgrey","disabledBackgroundColor":"white"},"keyframes":{}},
    "",
    1,
    /*! ../node_modules/wix-ui-core/dist/src/components/dropdown-option/DropdownOption.st.css */ 152,
    null
);
